/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CourierMessageStatus } from './courierMessageStatus';
import { MessageDispatch } from './messageDispatch';
import { CourierMessageType } from './courierMessageType';


export interface Message { 
    body: string;
    channel?: string;
    /**
     * CreatedAt is a helper struct field for gobuffalo.pop.
     */
    created_at: string;
    /**
     * Dispatches store information about the attempts of delivering a message May contain an error if any happened, or just the `success` state.
     */
    dispatches?: Array<MessageDispatch>;
    id: string;
    recipient: string;
    send_count: number;
    status: CourierMessageStatus;
    subject: string;
    /**
     *  recovery_invalid TypeRecoveryInvalid recovery_valid TypeRecoveryValid recovery_code_invalid TypeRecoveryCodeInvalid recovery_code_valid TypeRecoveryCodeValid verification_invalid TypeVerificationInvalid verification_valid TypeVerificationValid verification_code_invalid TypeVerificationCodeInvalid verification_code_valid TypeVerificationCodeValid stub TypeTestStub login_code_valid TypeLoginCodeValid registration_code_valid TypeRegistrationCodeValid
     */
    template_type: Message.TemplateTypeEnum;
    type: CourierMessageType;
    /**
     * UpdatedAt is a helper struct field for gobuffalo.pop.
     */
    updated_at: string;
}
export namespace Message {
    export type TemplateTypeEnum = 'recovery_invalid' | 'recovery_valid' | 'recovery_code_invalid' | 'recovery_code_valid' | 'verification_invalid' | 'verification_valid' | 'verification_code_invalid' | 'verification_code_valid' | 'stub' | 'login_code_valid' | 'registration_code_valid';
    export const TemplateTypeEnum = {
        RecoveryInvalid: 'recovery_invalid' as TemplateTypeEnum,
        RecoveryValid: 'recovery_valid' as TemplateTypeEnum,
        RecoveryCodeInvalid: 'recovery_code_invalid' as TemplateTypeEnum,
        RecoveryCodeValid: 'recovery_code_valid' as TemplateTypeEnum,
        VerificationInvalid: 'verification_invalid' as TemplateTypeEnum,
        VerificationValid: 'verification_valid' as TemplateTypeEnum,
        VerificationCodeInvalid: 'verification_code_invalid' as TemplateTypeEnum,
        VerificationCodeValid: 'verification_code_valid' as TemplateTypeEnum,
        Stub: 'stub' as TemplateTypeEnum,
        LoginCodeValid: 'login_code_valid' as TemplateTypeEnum,
        RegistrationCodeValid: 'registration_code_valid' as TemplateTypeEnum
    };
}


